import { render, staticRenderFns } from "./Renew.vue?vue&type=template&id=2285d6af&scoped=true&"
import script from "./Renew.vue?vue&type=script&lang=ts&"
export * from "./Renew.vue?vue&type=script&lang=ts&"
import style0 from "./Renew.vue?vue&type=style&index=0&id=2285d6af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2285d6af",
  null
  
)

export default component.exports